module.exports = __webpack_public_path__ + "img/middleright1.863414d4.png";